
const ChartsIcon = (props: any = {}) => {
    return (
        <svg width="16" height="16" {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.91512 6.79932V11.3727" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.02742 4.61182V11.3736" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.087 9.21582V11.3725" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M11.1254 1.33057H4.87782C2.70004 1.33057 1.33496 2.87196 1.33496 5.054V10.9405C1.33496 13.1225 2.69369 14.6639 4.87782 14.6639H11.1254C13.3096 14.6639 14.6683 13.1225 14.6683 10.9405V5.054C14.6683 2.87196 13.3096 1.33057 11.1254 1.33057Z" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default ChartsIcon